/** Format `sourceTable` + `sourceRowId` for display (mock uses `Table:rowId`). */
export function formatCalcLogProvenance(
  sourceTable: string,
  sourceRowId: string,
): string {
  const prefix = `${sourceTable}:`
  if (sourceRowId.startsWith(prefix)) {
    return `${sourceTable}#${sourceRowId.slice(prefix.length)}`
  }
  return `${sourceTable}#${sourceRowId}`
}
